import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../../models/GenericTableViewModel";
import { removeClient, updateClient } from "../../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { UserTypes } from "../../../enum/UserTypes";
import { useNavigate } from "react-router-dom";
import { siteEquipmentRemove, siteEquipmentUpdate } from "../../../service/siteService";

export default function SiteDSTI(props: RouteComponentProps) {
  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [equipmentIds, setEquipmentIds] = useState<string[]>([]);

  const toast = useRef(null as any);

  let url = "dsti-list";

  const baseFilter = {
    employee_full: { value: "", matchMode: FilterMatchMode.CONTAINS },
    status: { value: "", matchMode: FilterMatchMode.CONTAINS },
    created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRecord);
    removeClient(selectedRecord.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    // props.setGlobalLoader(true);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    if (props.setEquipment) {
      console.log("Set Equipment ");
      props.setEquipment(value);
    }
    setSelectedRecord(value);
    DialogSetVisible(row);
    // navigate('/equipment-view');
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const client = await siteEquipmentRemove(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: "Equipment Deleted Successfully",
      life: 3000,
    });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await siteEquipmentUpdate({ "active": status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: status ? "Equipment Activated Successfully" : "Equipment Deactivated Successfully",
      life: 3000,
    });
  };

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to deactivate equipment?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(false),
    });
  };

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to activate equipment?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => changeStatusFunc(true),
    });
  };

  const DialogSetVisible = (row: any) => {
    setVisible(true);
  };

  const viewSelected = (row: any) => {
    let breadcrumbs = props.breadcrumbs;
    breadcrumbs.push({
      label: selectedRecord.full_name,
      link: "/equipment-view",
      userType: UserTypes.Site,
    });
    props.setBreadcrumbs(breadcrumbs);
    navigate("/equipment-view");
  };

  const contextItems = () => {
    let objArray = [
      // { label: 'View', icon: 'pi pi-fw pi-eye', command: viewSelected },
      // { label: "Edit", icon: "pi pi-fw pi-pencil", command: DialogSetVisible },
    ];
    if (selectedRecord?.active) {
      objArray.push({
        label: "Deactivate",
        icon: "pi pi-fw pi-times-circle",
        command: disableConfirm,
      });
    } else {
      objArray.push({
        label: "Activate",
        icon: "pi pi-fw pi-check-circle",
        command: activateConfirm,
      });
    }
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "employee_full",
      header: "Responsible Person",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "status",
      header: "Status",
      type: GenericTableColumTypes.Status,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Status,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "created_at",
      header: "Date",
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Date,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    }
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          DSTI
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url={url}
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        // itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
        callbackOnLoad={(data: any) => {
          setEquipmentIds(data.map((item: any) => item.equipment) || []);
        }}
      />

      <Dialog
        header={selectedRecord?.id ? "Update Equipment" : "Add Equipment"}
        visible={visible}
        style={{ width: "95vw", height: "75vh", maxWidth: "1440px" }}
        onHide={() => setVisible(false)}
      >
        {/* <SiteEquipmentAdd
          setGlobalLoading={props.setGlobalLoader}
          record={selectedRecord}
          setReload={setReload}
          reload={reload}
          setVisible={setVisible}
          toast={toast}
          session={props.session}
          equipmentIds={equipmentIds}
        /> */}
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
